(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('ResidencyQuestionsService', ResidencyQuestionsService);

    ResidencyQuestionsService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function ResidencyQuestionsService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();